export default function getParameters(price){
    return { price: price};
}